import React, { useContext, useEffect, useState } from 'react';
import AuthContext from '../../../../authentication/AuthContext';
import axios from 'axios';

export default function PostSubmissionBanner() {
    const cas = useContext(AuthContext);
    const [bannerImage, setBannerImage] = useState();

    useEffect(() => {
        axios
            .get(window.CONFIG['ws.activoc-web-order-api.confirmed-order-banner'], {
                headers: {
                    Authorization: cas,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => setBannerImage(response.data.completedOrderBanner));
    }, [cas]);

    return (
        <div className={'content'}>
            {bannerImage && (
                <img className={'post-submission-banner'} src={bannerImage} alt={'post-submission promo'} />
            )}
        </div>
    );
}
